import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "ml-2 text-caption"
}
const _hoisted_3 = {
  key: 1,
  class: "ml-2 text-caption"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-3 text-caption"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_6 = { class: "section-header" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_10 = { class: "font-weight-medium text-no-wrap" }
const _hoisted_11 = { class: "text-no-wrap" }
const _hoisted_12 = { class: "text-no-wrap" }
const _hoisted_13 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_14 = { class: "section-header" }
const _hoisted_15 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "font-weight-medium" }
const _hoisted_19 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_20 = { class: "section-header" }
const _hoisted_21 = { class: "rate-key-name" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "rate-key-details"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "font-weight-medium" }
const _hoisted_28 = { class: "font-weight-medium" }
const _hoisted_29 = {
  key: 4,
  class: "mb-4"
}
const _hoisted_30 = { class: "section-header" }
const _hoisted_31 = {
  key: 0,
  class: "font-weight-medium"
}
const _hoisted_32 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_35 = {
  key: 5,
  class: "mb-4"
}
const _hoisted_36 = { class: "section-header" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_39 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_40 = { class: "font-weight-medium" }
const _hoisted_41 = {
  key: 6,
  class: "mb-4"
}
const _hoisted_42 = { class: "section-header" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_45 = { class: "font-weight-medium" }
const _hoisted_46 = {
  key: 7,
  class: "mb-3"
}
const _hoisted_47 = { class: "section-header" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 8,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_51 = {
  key: 0,
  class: "text-center py-6 text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: $setup.activeDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.activeDialog) = $event)),
      transition: "dialog-bottom-transition",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Trace Worksheet Analyzer")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      "prepend-icon": "mdi-close",
                      onClick: $setup.closeAnalyzer
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Close")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode($setup["WaitDialog"], {
              "is-active": $setup.isLoading,
              title: "Loading trace worksheet..."
            }, null, 8 /* PROPS */, ["is-active"]),
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                _createCommentVNode(" Error display "),
                ($setup.errorMessage)
                  ? (_openBlock(), _createBlock(_component_v_container, {
                      key: 0,
                      class: "px-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode($setup["UserNotification"], {
                          message: $setup.errorMessage,
                          closable: true
                        }, null, 8 /* PROPS */, ["message"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Header card "),
                ($setup.parsedWorksheet)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 1,
                      class: "mb-4",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { align: "center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Policy:", -1 /* HOISTED */)),
                                    _createTextVNode(" " + _toDisplayString($setup.parsedWorksheet.header.policyNumber), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Correlation ID:", -1 /* HOISTED */)),
                                    _createTextVNode(" " + _toDisplayString($setup.parsedWorksheet.header.correlationId), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Effective:", -1 /* HOISTED */)),
                                    _createTextVNode(" " + _toDisplayString($setup.parsedWorksheet.header.effectiveDate), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Entry:", -1 /* HOISTED */)),
                                    _createTextVNode(" " + _toDisplayString($setup.parsedWorksheet.header.entryDate), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "1" }, {
                                  default: _withCtx(() => [
                                    _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Environment:", -1 /* HOISTED */)),
                                    _createTextVNode(" " + _toDisplayString($setup.parsedWorksheet.header.environment), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "text-right"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tooltip, {
                                      text: "Download Trace Worksheet",
                                      location: "bottom"
                                    }, {
                                      activator: _withCtx(({ props: tooltipProps }) => [
                                        _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
                                          icon: "mdi-download",
                                          color: "primary",
                                          variant: "text",
                                          onClick: $setup.downloadFile
                                        }), null, 16 /* FULL_PROPS */)
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Filters toolbar "),
                ($setup.parsedWorksheet)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      class: "mb-4",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                      modelValue: $setup.filters.algorithmName,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.algorithmName) = $event)),
                                      items: $setup.distinctAlgorithmNames,
                                      label: "Algorithm Name",
                                      clearable: "",
                                      variant: "solo-filled",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                      modelValue: $setup.filters.state,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.state) = $event)),
                                      items: $setup.distinctStates,
                                      label: "State",
                                      clearable: "",
                                      variant: "solo-filled",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                      modelValue: $setup.filters.lineOfBusiness,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.lineOfBusiness) = $event)),
                                      items: $setup.distinctLinesOfBusiness,
                                      label: "Line of Business",
                                      clearable: "",
                                      variant: "solo-filled",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                      modelValue: $setup.filters.rateKeyName,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.rateKeyName) = $event)),
                                      items: $setup.distinctRateKeyNames,
                                      label: "Rate Key",
                                      clearable: "",
                                      variant: "solo-filled",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.filters.searchText,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.searchText) = $event)),
                                      label: "Search (rate keys, activity, etc.)",
                                      clearable: "",
                                      "prepend-inner-icon": "mdi-magnify",
                                      variant: "solo-filled",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: $setup.clearFilters,
                                      color: "primary",
                                      variant: "text",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode(" Clear All ")
                                      ])),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Selection indicator "),
                _createVNode(_component_v_slide_y_transition, null, {
                  default: _withCtx(() => [
                    ($setup.parsedWorksheet && $setup.selectedAlgorithms.size > 0)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          class: "mb-4 selection-bar",
                          color: "primary",
                          variant: "tonal"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "d-flex align-center py-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "mr-2" }, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode("mdi-checkbox-multiple-marked-outline")
                                  ])),
                                  _: 1 /* STABLE */
                                }),
                                _createElementVNode("strong", null, _toDisplayString($setup.selectedAlgorithms.size) + " algorithm" + _toDisplayString($setup.selectedAlgorithms.size > 1 ? 's' : '') + " selected", 1 /* TEXT */),
                                ($setup.showSelectedOnly)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(comparing selected algorithms)"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_3, "(click \"Show Selected\" to compare)")),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  onClick: $setup.clearSelection,
                                  variant: "outlined",
                                  size: "small",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                    _createTextVNode(" Clear Selection ")
                                  ])),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode(" Main content: Stats + Algorithms "),
                ($setup.parsedWorksheet && $setup.stats)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 3,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createCommentVNode(" Stats sidebar: drawer style "),
                        _createVNode(_component_v_col, {
                          cols: $setup.statsVisible ? 3 : 'auto',
                          class: "pr-3 stats-sidebar"
                        }, {
                          default: _withCtx(() => [
                            _createCommentVNode(" Collapsed strip "),
                            (!$setup.statsVisible)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  variant: "outlined",
                                  class: "stats-drawer-collapsed",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.statsVisible = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "small",
                                      class: "mb-2"
                                    }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode("mdi-chevron-right")
                                      ])),
                                      _: 1 /* STABLE */
                                    }),
                                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "stats-drawer-label" }, "Statistics", -1 /* HOISTED */))
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createCommentVNode(" Expanded panel "),
                                  _createVNode(_component_v_card, {
                                    variant: "outlined",
                                    class: "text-left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { class: "text-subtitle-1 d-flex align-center" }, {
                                        default: _withCtx(() => [
                                          _cache[26] || (_cache[26] = _createElementVNode("span", null, "Statistics", -1 /* HOISTED */)),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.statsVisible = false)),
                                            icon: "",
                                            variant: "text",
                                            size: "x-small",
                                            title: "Collapse statistics panel"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                  _createTextVNode("mdi-chevron-left")
                                                ])),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }),
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, { density: "compact" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Total Algorithms:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.stats.totalAlgorithms), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Filtered:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.filteredAlgorithms.length), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Distinct Names:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.stats.distinctAlgorithmNames.length), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[30] || (_cache[30] = _createElementVNode("strong", null, "States:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.stats.distinctStates.join(', ')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Lines of Business:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.stats.distinctLinesOfBusiness.join(', ')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Insurance Lines:", -1 /* HOISTED */)),
                                                  _createTextVNode(" " + _toDisplayString($setup.stats.distinctInsuranceLines.join(', ')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_divider, { class: "my-2" }),
                                              _createVNode(_component_v_list_subheader, null, {
                                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                  _createTextVNode("Activity Breakdown")
                                                ])),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "info",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                      _createTextVNode("mdi-help-circle-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Conditions: " + _toDisplayString($setup.stats.totalConditions), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "success",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                      _createTextVNode("mdi-pencil-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Set Operations: " + _toDisplayString($setup.stats.totalSetOperations), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "warning",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                                                      _createTextVNode("mdi-key-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Rate Key Lookups: " + _toDisplayString($setup.stats.totalRateKeyLookups), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "secondary",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                      _createTextVNode("mdi-file-document-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Form Operations: " + _toDisplayString($setup.stats.totalFormOperations), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "primary",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                      _createTextVNode("mdi-calculator-variant-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Arithmetic: " + _toDisplayString($setup.stats.totalArithmeticOperations), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    color: "info",
                                                    class: "mr-1"
                                                  }, {
                                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                      _createTextVNode("mdi-check-decagram-outline")
                                                    ])),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode(" Evaluations: " + _toDisplayString($setup.stats.totalEvaluations), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }),
                                              _createVNode(_component_v_divider, { class: "my-2" }),
                                              _createVNode(_component_v_list_subheader, null, {
                                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                  _createTextVNode("Sections")
                                                ])),
                                                _: 1 /* STABLE */
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stats.sectionSummaries, (s) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: s.name
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(s.name) + ": " + _toDisplayString(s.algorithmCount), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["cols"]),
                        _createCommentVNode(" Algorithm list "),
                        _createVNode(_component_v_col, { class: "algorithms-column" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              variant: "outlined",
                              class: "text-left"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "text-subtitle-1 d-flex align-center" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, "Algorithms (" + _toDisplayString($setup.filteredAlgorithms.length) + " of " + _toDisplayString($setup.stats.totalAlgorithms) + ")", 1 /* TEXT */),
                                    _createVNode(_component_v_spacer),
                                    ($setup.showSelectedOnly)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 0,
                                          onClick: $setup.expandAllSelected,
                                          variant: "text",
                                          size: "small",
                                          class: "mr-1",
                                          "prepend-icon": "mdi-arrow-expand-vertical"
                                        }, {
                                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                                            _createTextVNode(" Expand All ")
                                          ])),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.showSelectedOnly)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 1,
                                          onClick: $setup.collapseAllSelected,
                                          variant: "text",
                                          size: "small",
                                          class: "mr-2",
                                          "prepend-icon": "mdi-arrow-collapse-vertical"
                                        }, {
                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                            _createTextVNode(" Collapse All ")
                                          ])),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.selectedAlgorithms.size > 0 && !$setup.showSelectedOnly)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 2,
                                          onClick: $setup.enterSelectedView,
                                          variant: "tonal",
                                          color: "primary",
                                          size: "small",
                                          class: "mr-2",
                                          "prepend-icon": "mdi-filter-check-outline"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Show Selected (" + _toDisplayString($setup.selectedAlgorithms.size) + ") ", 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.showSelectedOnly)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 3,
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showSelectedOnly = false)),
                                          variant: "tonal",
                                          color: "secondary",
                                          size: "small",
                                          class: "mr-2",
                                          "prepend-icon": "mdi-filter-remove-outline"
                                        }, {
                                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                                            _createTextVNode(" Show All ")
                                          ])),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_card_text, { class: "algorithms-scroll" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panels, {
                                      modelValue: $setup.openPanels,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.openPanels) = $event)),
                                      multiple: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedAlgorithms, (algo) => {
                                          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                            key: algo.lineNumber,
                                            value: algo.lineNumber,
                                            class: _normalizeClass({ 'selected-panel': $setup.isSelected(algo) })
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_title, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    align: "center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "auto",
                                                        class: "mr-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_checkbox_btn, {
                                                            "model-value": $setup.isSelected(algo),
                                                            "onUpdate:modelValue": ($event: any) => ($setup.toggleSelection(algo)),
                                                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                                            color: "primary",
                                                            density: "compact"
                                                          }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, { cols: "1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_chip, {
                                                            size: "x-small",
                                                            color: "primary",
                                                            variant: "tonal"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(algo.index) + "/" + _toDisplayString(algo.total), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                          }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, { cols: "3" }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("strong", null, _toDisplayString(algo.algorithmName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, { cols: "2" }, {
                                                        default: _withCtx(() => [
                                                          (algo.state)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 0,
                                                                size: "x-small",
                                                                color: "info",
                                                                variant: "tonal"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" State: " + _toDisplayString(algo.state), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */))
                                                            : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, { cols: "2" }, {
                                                        default: _withCtx(() => [
                                                          (algo.line)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 0,
                                                                size: "x-small",
                                                                color: "warning",
                                                                variant: "tonal"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Line: " + _toDisplayString(algo.line), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */))
                                                            : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, { cols: "1" }, {
                                                        default: _withCtx(() => [
                                                          (algo.lob)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 0,
                                                                size: "x-small",
                                                                color: "success",
                                                                variant: "tonal"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(algo.lob), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */))
                                                            : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */),
                                                      _createVNode(_component_v_col, {
                                                        cols: "2",
                                                        class: "text-caption text-medium-emphasis"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(algo.shortName) + " (L" + _toDisplayString(algo.lineNumber) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */),
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [
                                                  (algo.product || algo.unit || algo.coverage)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                        (algo.product)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 0,
                                                              size: "x-small",
                                                              variant: "tonal",
                                                              class: "mr-1"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("Product: " + _toDisplayString(algo.product), 1 /* TEXT */)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */))
                                                          : _createCommentVNode("v-if", true),
                                                        (algo.unit)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 1,
                                                              size: "x-small",
                                                              variant: "tonal",
                                                              class: "mr-1"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("Unit: " + _toDisplayString(algo.unit), 1 /* TEXT */)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */))
                                                          : _createCommentVNode("v-if", true),
                                                        (algo.coverage)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 2,
                                                              size: "x-small",
                                                              variant: "tonal"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("Coverage: " + _toDisplayString(algo.coverage), 1 /* TEXT */)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */))
                                                          : _createCommentVNode("v-if", true)
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Conditions table "),
                                                  ($setup.getActivitiesByType(algo, 'condition').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                        _createElementVNode("div", _hoisted_6, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "info",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                                              _createTextVNode("mdi-help-circle-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Conditions (" + _toDisplayString($setup.getActivitiesByType(algo, 'condition').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _createVNode(_component_v_data_table, {
                                                          headers: $setup.conditionHeaders,
                                                          items: $setup.getActivitiesByType(algo, 'condition'),
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          density: "compact",
                                                          class: "activity-table"
                                                        }, {
                                                          [`item.attribute`]: _withCtx(({ item }) => [
                                                            (item.condition)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  ($setup.filters.searchText)
                                                                    ? (_openBlock(), _createElementBlock("span", {
                                                                        key: 0,
                                                                        innerHTML: $setup.highlightSearch(item.condition.attribute, $setup.filters.searchText)
                                                                      }, null, 8 /* PROPS */, _hoisted_7))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.condition.attribute), 1 /* TEXT */))
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.rawText), 1 /* TEXT */))
                                                          ]),
                                                          [`item.actualValue`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.condition?.actualValue), 1 /* TEXT */)
                                                          ]),
                                                          [`item.operator`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.condition?.operator), 1 /* TEXT */)
                                                          ]),
                                                          [`item.expectedValue`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.condition?.expectedValue), 1 /* TEXT */)
                                                          ]),
                                                          [`item.result`]: _withCtx(({ item }) => [
                                                            (item.condition)
                                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                  key: 0,
                                                                  color: item.condition.result ? 'success' : 'error',
                                                                  size: "x-small",
                                                                  variant: "tonal"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.condition.result ? 'TRUE' : 'FALSE'), 1 /* TEXT */)
                                                                  ]),
                                                                  _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Set operations table "),
                                                  ($setup.getActivitiesByType(algo, 'set').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                        _createElementVNode("div", _hoisted_14, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "success",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                                              _createTextVNode("mdi-pencil-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Set Operations (" + _toDisplayString($setup.getActivitiesByType(algo, 'set').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _createVNode(_component_v_data_table, {
                                                          headers: $setup.setHeaders,
                                                          items: $setup.getActivitiesByType(algo, 'set'),
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          density: "compact",
                                                          class: "activity-table"
                                                        }, {
                                                          [`item.targetType`]: _withCtx(({ item }) => [
                                                            (item.set)
                                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                  key: 0,
                                                                  size: "x-small",
                                                                  variant: "tonal",
                                                                  color: item.set.targetType === 'Attribute' ? 'primary' : 'secondary'
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.set.targetType === 'Attribute' ? 'Attr' : 'NRE'), 1 /* TEXT */)
                                                                  ]),
                                                                  _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.rawText), 1 /* TEXT */))
                                                          ]),
                                                          [`item.target`]: _withCtx(({ item }) => [
                                                            (item.set)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  ($setup.filters.searchText)
                                                                    ? (_openBlock(), _createElementBlock("span", {
                                                                        key: 0,
                                                                        innerHTML: $setup.highlightSearch(item.set.target, $setup.filters.searchText)
                                                                      }, null, 8 /* PROPS */, _hoisted_16))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.set.target), 1 /* TEXT */))
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          [`item.value`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.set?.value), 1 /* TEXT */)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Rate Keys (stacked: lookup header + results per key) "),
                                                  ($setup.getRateKeyGroups(algo).length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _createElementVNode("div", _hoisted_20, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "warning",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                                              _createTextVNode("mdi-key-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _cache[47] || (_cache[47] = _createTextVNode(" Rate Keys "))
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getRateKeyGroups(algo), (group, gIdx) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: 'rkg'+gIdx,
                                                            class: "rate-key-block mb-2"
                                                          }, [
                                                            _createElementVNode("div", _hoisted_21, [
                                                              ($setup.filters.searchText)
                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                    key: 0,
                                                                    innerHTML: $setup.highlightSearch(group.keyName, $setup.filters.searchText)
                                                                  }, null, 8 /* PROPS */, _hoisted_22))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(group.keyName), 1 /* TEXT */))
                                                            ]),
                                                            (group.lookup)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal",
                                                                    class: "mr-1"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("Eff: " + _toDisplayString(group.lookup.effectiveDate), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal",
                                                                    class: "mr-1"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("State: " + _toDisplayString(group.lookup.state), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal",
                                                                    class: "mr-1"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("LOB: " + _toDisplayString(group.lookup.lob), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal",
                                                                    class: "mr-1"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("Line: " + _toDisplayString(group.lookup.line), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal",
                                                                    class: "mr-1"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("Product: " + _toDisplayString(group.lookup.product), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */),
                                                                  _createVNode(_component_v_chip, {
                                                                    size: "x-small",
                                                                    variant: "tonal"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("Coverage: " + _toDisplayString(group.lookup.coverage), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                  }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]))
                                                              : _createCommentVNode("v-if", true),
                                                            (group.results.length)
                                                              ? (_openBlock(), _createBlock(_component_v_data_table, {
                                                                  key: 1,
                                                                  headers: $setup.rateKeyResultHeaders,
                                                                  items: group.results,
                                                                  "items-per-page": -1,
                                                                  "hide-default-footer": "",
                                                                  density: "compact",
                                                                  class: "activity-table rate-key-results"
                                                                }, {
                                                                  [`item.keyName`]: _withCtx(({ item }) => [
                                                                    ($setup.filters.searchText)
                                                                      ? (_openBlock(), _createElementBlock("span", {
                                                                          key: 0,
                                                                          innerHTML: $setup.highlightSearch(item.keyName, $setup.filters.searchText)
                                                                        }, null, 8 /* PROPS */, _hoisted_25))
                                                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.keyName), 1 /* TEXT */))
                                                                  ]),
                                                                  [`item.lookupValue`]: _withCtx(({ item }) => [
                                                                    _createElementVNode("span", _hoisted_27, _toDisplayString(item.lookupValue), 1 /* TEXT */)
                                                                  ]),
                                                                  [`item.result`]: _withCtx(({ item }) => [
                                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.result), 1 /* TEXT */)
                                                                  ]),
                                                                  _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"]))
                                                              : _createCommentVNode("v-if", true)
                                                          ]))
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Form operations "),
                                                  ($setup.getActivitiesByType(algo, 'form').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                        _createElementVNode("div", _hoisted_30, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "secondary",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                                              _createTextVNode("mdi-file-document-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Forms (" + _toDisplayString($setup.getActivitiesByType(algo, 'form').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _createVNode(_component_v_data_table, {
                                                          headers: $setup.formHeaders,
                                                          items: $setup.getActivitiesByType(algo, 'form'),
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          density: "compact",
                                                          class: "activity-table"
                                                        }, {
                                                          [`item.formNumber`]: _withCtx(({ item }) => [
                                                            (item.form)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.form.formNumber), 1 /* TEXT */))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.rawText), 1 /* TEXT */))
                                                          ]),
                                                          [`item.formEdition`]: _withCtx(({ item }) => [
                                                            (item.form)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(item.form.formEdition), 1 /* TEXT */))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          [`item.action`]: _withCtx(({ item }) => [
                                                            (item.form)
                                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                  key: 0,
                                                                  size: "x-small",
                                                                  variant: "tonal",
                                                                  color: item.form.action === 'Attached' ? 'success' : item.form.action === 'Detached' ? 'error' : 'info'
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.form.action), 1 /* TEXT */)
                                                                  ]),
                                                                  _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          [`item.location`]: _withCtx(({ item }) => [
                                                            (item.form)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(item.form.location), 1 /* TEXT */))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Arithmetic "),
                                                  ($setup.getActivitiesByType(algo, 'arithmetic').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                        _createElementVNode("div", _hoisted_36, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "primary",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                                              _createTextVNode("mdi-calculator-variant-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Arithmetic (" + _toDisplayString($setup.getActivitiesByType(algo, 'arithmetic').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _createVNode(_component_v_data_table, {
                                                          headers: $setup.arithmeticHeaders,
                                                          items: $setup.getActivitiesByType(algo, 'arithmetic'),
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          density: "compact",
                                                          class: "activity-table"
                                                        }, {
                                                          [`item.attribute`]: _withCtx(({ item }) => [
                                                            (item.arithmetic)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.arithmetic.attribute), 1 /* TEXT */))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(item.rawText), 1 /* TEXT */))
                                                          ]),
                                                          [`item.currentValue`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", null, _toDisplayString(item.arithmetic?.currentValue), 1 /* TEXT */)
                                                          ]),
                                                          [`item.operator`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", null, _toDisplayString(item.arithmetic?.operator), 1 /* TEXT */)
                                                          ]),
                                                          [`item.operand`]: _withCtx(({ item }) => [
                                                            (item.arithmetic)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  (item.arithmetic.operandLabel)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.arithmetic.operandLabel), 1 /* TEXT */))
                                                                    : _createCommentVNode("v-if", true),
                                                                  _createTextVNode(" " + _toDisplayString(item.arithmetic.operand), 1 /* TEXT */)
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          [`item.result`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_40, _toDisplayString(item.arithmetic?.result), 1 /* TEXT */)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Evaluations "),
                                                  ($setup.getActivitiesByType(algo, 'evaluation').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "info",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                                              _createTextVNode("mdi-check-decagram-outline")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Evaluations (" + _toDisplayString($setup.getActivitiesByType(algo, 'evaluation').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        _createVNode(_component_v_data_table, {
                                                          headers: $setup.evaluationHeaders,
                                                          items: $setup.getActivitiesByType(algo, 'evaluation'),
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          density: "compact",
                                                          class: "activity-table"
                                                        }, {
                                                          [`item.attribute`]: _withCtx(({ item }) => [
                                                            (item.evaluation)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(item.evaluation.attribute), 1 /* TEXT */))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(item.rawText), 1 /* TEXT */))
                                                          ]),
                                                          [`item.value`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", _hoisted_45, _toDisplayString(item.evaluation?.value), 1 /* TEXT */)
                                                          ]),
                                                          [`item.condition`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", null, _toDisplayString(item.evaluation?.condition), 1 /* TEXT */)
                                                          ]),
                                                          [`item.qualifies`]: _withCtx(({ item }) => [
                                                            (item.evaluation)
                                                              ? (_openBlock(), _createElementBlock("span", {
                                                                  key: 0,
                                                                  class: _normalizeClass(["font-weight-bold", item.evaluation.qualifies ? 'text-success' : 'text-error'])
                                                                }, _toDisplayString(item.evaluation.qualifies ? 'Yes' : 'No'), 3 /* TEXT, CLASS */))
                                                              : _createCommentVNode("v-if", true)
                                                          ]),
                                                          [`item.target`]: _withCtx(({ item }) => [
                                                            _createElementVNode("span", null, _toDisplayString(item.evaluation?.target), 1 /* TEXT */)
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  _createCommentVNode(" Other/unclassified "),
                                                  ($setup.getActivitiesByType(algo, 'other').length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                        _createElementVNode("div", _hoisted_47, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "x-small",
                                                            color: "grey",
                                                            class: "mr-1"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                                              _createTextVNode("mdi-dots-horizontal")
                                                            ]))]),
                                                            _: 1 /* STABLE */
                                                          }),
                                                          _createTextVNode(" Other (" + _toDisplayString($setup.getActivitiesByType(algo, 'other').length) + ") ", 1 /* TEXT */)
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getActivitiesByType(algo, 'other'), (act, idx) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: 'o'+idx,
                                                            class: "other-line text-caption py-1"
                                                          }, [
                                                            ($setup.filters.searchText)
                                                              ? (_openBlock(), _createElementBlock("span", {
                                                                  key: 0,
                                                                  innerHTML: $setup.highlightSearch(act.rawText, $setup.filters.searchText)
                                                                }, null, 8 /* PROPS */, _hoisted_48))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(act.rawText), 1 /* TEXT */))
                                                          ]))
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                      ]))
                                                    : _createCommentVNode("v-if", true),
                                                  (algo.activities.length === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, " No activity lines recorded for this execution. "))
                                                    : _createCommentVNode("v-if", true)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "class"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"]),
                                    ($setup.filteredAlgorithms.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, " No algorithms match the current filters. "))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createCommentVNode(" Pagination "),
                                ($setup.totalPages > 1 && !$setup.showSelectedOnly)
                                  ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { align: "center" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select, {
                                                  modelValue: $setup.itemsPerPage,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.itemsPerPage) = $event)),
                                                  items: [10, 25, 50, 100],
                                                  label: "Per page",
                                                  density: "compact",
                                                  variant: "solo-filled"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex justify-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_pagination, {
                                                  modelValue: $setup.currentPage,
                                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.currentPage) = $event)),
                                                  length: $setup.totalPages,
                                                  "total-visible": 7
                                                }, null, 8 /* PROPS */, ["modelValue", "length"])
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center justify-end text-caption"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.filteredAlgorithms.length) + " algorithms ", 1 /* TEXT */)
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}